import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Container } from "./DataCard.styled"
import DataCard from "./DataCard"
import DineroFactory from "dinero.js"
import Dinero from "dinero.js"
import { useCurrencyConversion } from "./hooks/useCurrencyConversion"

interface DataObj {
  name: string
  value: number
}

interface AnalyticsOrdersOverviewProps {
  timeZone: string
  currencyCode: string
  totalOrders: number
  data: DataObj[]
  filterCurrencies: string[]
  ratesMap: Record<string, Record<string, number>>
  loadingRates: boolean
}

export const AnalyticsOrdersOverview = (
  {
    totalOrders,
    data,
    currencyCode,
    filterCurrencies,
    ratesMap,
    loadingRates
  }: AnalyticsOrdersOverviewProps) => {
  if (filterCurrencies?.length === 0) {
    return
  }
  const navigate = useNavigate()

  const [averageSalesPerOrder, setAverageSalesPerOrder] = useState<DineroFactory.Dinero>()

  const {
    totalAmount: totalSales,
  } = useCurrencyConversion(data, currencyCode, ratesMap, {
    skipMissingRates: true,
    onError: (error) => console.error("Conversion error:", error),
  })

  useEffect(() => {
    setAverageSalesPerOrder(Dinero({ amount: 0, currency: currencyCode as DineroFactory.Currency }))
    if (!totalSales || totalOrders === 0) {
      return
    }
    const average = totalSales?.divide(totalOrders)
    setAverageSalesPerOrder(average)
  }, [totalSales, data])

  const cards = [
    {
      label: "Total Orders",
      value: totalOrders,
      onClick: () => navigate("/orders")
    },
    {
      label: "Total Sales",
      value: Math.round(totalSales?.toUnit() ?? 0),
      currency: currencyCode,
      onClick: () => navigate("/orders")
    },
    {
      label: "Average Sale",
      value: Math.round(averageSalesPerOrder?.toUnit() ?? 0),
      currency: currencyCode,
      onClick: () => navigate("/orders")
    }
  ]

  return (
    <Container className={loadingRates ? "blur" : ""}>
      {cards.map((card, index) => (
        <DataCard
          key={index}
          label={card.label}
          value={card.value}
          currency={card.currency}
          handleOnClick={card.onClick}
        />
      ))}
    </Container>
  )
}
